import * as React from 'react';
import { PureComponent } from 'react';
import { classNames } from '@tolkam/lib-utils-ui';
import LazyImage from '@tolkam/react-lazy-image';
import './styles';

class Picture extends PureComponent<IProps, IState> {

    /**
     * @type {IProps}
     */
    public static defaultProps = {
        lazy: true,
        lazyOffsetY: '-10%',
    };

    /**
     * @type {IState}
     */
    public state = {
        loadState: '',
    };

    /**
     * @type {HTMLElement}
     */
    protected el: HTMLElement;

    /**
     * @inheritDoc
     */
    public render() {
        const that = this;
        const { props } = that;
        const { src, color, lqp, lazyOffsetY, lazyOffsetX } = props;
        const loadState = that.state.loadState;
        const alt = props.alt || '';

        const baseClass = 'jc-picture';
        const className = classNames(baseClass, props.className, {
            ['-state-' + loadState] : loadState,
            ['-lqp'] : !!lqp,
        });

        const style: any = {};
        if(color) {
            style.backgroundColor = '#' + color;
        }
        if(lqp) {
            style.backgroundImage = 'url(' + lqp + ')';
        }

        let image = <LazyImage
            src={src}
            lazy={props.lazy}
            lazyOffset={{top: lazyOffsetY, bottom: lazyOffsetY, left: lazyOffsetX, right: lazyOffsetX}}
            onChanges={that.onChanges}
            alt={alt}
        />;

        if(props.withSourceLink) {
            image = <a href={src}>{image}</a>
        }

        return <div className={className} style={style}>
            <div className={baseClass + '_image'}>{image}</div>
        </div>;
    }

    /**
     * @param {string} loadState
     */
    protected onChanges = (loadState: string) => {
        this.setState({ loadState });
    };
}

interface IProps extends React.HTMLProps<HTMLImageElement> {
    src: string;
    lqp?: string;
    color?: string;
    lazy?: boolean;
    lazyOffsetY?: string;
    lazyOffsetX?: string;
    withSourceLink?: boolean;
}

interface IState {
    loadState: string;
}

export default Picture;
export { IProps }
